import app from '../app';

if (window.Fancybox) {
  Fancybox.Plugins.Thumbs.defaults.autoStart = false;
  Fancybox.Plugins.Toolbar.defaults.display = ['counter', 'close'];

  Fancybox.bind('[data-fancybox]', {
    on: {
      reveal: (fancybox, slide) => {
        const { type } = slide;
        if (type.includes('video') && window.Plyr) {
          new Plyr(slide.$el.querySelector('video'), {
            muted: false,
            controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen'],
          });
        }
      },
    },
  });

  app.el.$main.on('click', '[data-fancybox-qrcode]', e => {
    e.preventDefault();
    let el = e.currentTarget;
    let text = el.dataset.fancyboxQrcode;
    let src = el.href;
    new Fancybox([
      {
        src: `<img src=${src} /><div class="text-center mt-2">${text}</div>`,
        type: 'html',
      },
    ]);
  });
}
